
import { Component, Inject, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { InstitutionService } from "../../services/institution.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public openNav = false;
  public currentRoute: string = '';
  public role: string | null = '';
  public institutionData: any;
  public instituteProfileImg: string = '';
  public instituteShow: boolean = false;
  public showProfile: boolean = false;

  constructor(
    private route: ActivatedRoute, private translate: TranslateService, public router: Router, private institutionService: InstitutionService
  ) {
    this.translate.setDefaultLang("en");

    // Update currentRoute on navigation end
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });
  }

  ngOnInit(): void {
    this.role = localStorage.getItem('role');

    switch (this.role) {
      case "PORTAL_INSTITUTION":
        this.instituteShow = true;
        this.getInstitutionByProfile();
        break;
      case "PROTAL_ADMIN":
      case "PORTAL_SPOC":
      case "PORTAL_MENTOR":
      default:
        this.instituteShow = false;
        break;
    }
  }

  public changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  public openMobileNav(): void {
    this.openNav = !this.openNav;
  }

  public logout(): void {
    this.router.navigate(["auth/login"]);
  }

  public change(): void {
    this.router.navigate(["auth/change-password"]);
  }

  public profile(): void {
    this.router.navigate(["/institute/institute-profile"]);
  }

  public getInstitutionByProfile(): void {
    this.institutionService.getInstitutionByProfile({}).subscribe(res => {
      if (res.status && res.data) {
        this.institutionData = res.data;
        if (this.institutionData.imageUrl) {
          this.instituteProfileImg = `${this.institutionData.imageUrl}?t=${new Date().getTime()}`;
          this.showProfile = true;
        } else {
          this.showProfile = false;
        }
      }
    });
  }

  public shouldShowNavbar(): boolean {
    return !this.currentRoute.includes('/questionnarie/');
  }
}
